/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React from 'react';
import { DiscoveryCard } from '@vfuk/core-discovery-card';
import { FeatureItemCardProps } from './types/FeatureItemCard.types';
import { DiscoveryCardWrapper } from './styes/FeatureItemCard.styles';

const ASPECT_RATIO = {
  vertical: '16/9',
  horizontal: '1/1',
};

const FeatureItemCard = ({ item }: FeatureItemCardProps) => {
  const {
    header,
    bodyText,
    bodyImage,
    urlLink,
    nameLink,
    justify,
    orientation,
  } = item;

  const itemImage = bodyImage &&
    bodyImage.gatsbyImageData && {
      alt: bodyImage.description || bodyImage.title,
      aspectRatio: ASPECT_RATIO[orientation],
      xl: {
        src: bodyImage.gatsbyImageData.images.sources[0].srcSet,
        srcSet: {
          x1: bodyImage.gatsbyImageData.images.sources[0].srcSet,
          x2: bodyImage.gatsbyImageData.images.sources[0].srcSet,
          x3: bodyImage.gatsbyImageData.images.sources[0].srcSet,
        },
        width: '100%',
        height: '200px',
      },
    };

  const link =
    urlLink && nameLink
      ? {
          text: nameLink,
          href: urlLink,
        }
      : undefined;

  return (
    <DiscoveryCardWrapper>
      <DiscoveryCard
        heading={{ text: header, level: 3 }}
        text={bodyText.bodyText}
        image={itemImage}
        link={link}
        justify={justify}
        orientation={orientation}
        elevation
      />
    </DiscoveryCardWrapper>
  );
};

export default FeatureItemCard;
